import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import DomTypeDelivery1 from '../../images/dom_pin_1.svg';
import DomTypeDelivery2 from '../../images/dom_pin_2.svg';
import ArrowBlue from '../../images/arrow_blue.svg';
import CounterConponent from '../../components/Counter';
import DatePickerComponent from '../../components/Datepicker';
import DomesticContext from './DomesticContext';
import SelectComponent from '../../components/Select';
import { DELIVERY_BY, PURPOSE_OF_TOURISM } from '../../data/domestic';
import { SpaceBox } from '../../components/Space';
import DataService from '../../service/data';
import { DateUtils, Alert, IdentityUtils } from '../../utils';
import moment from 'moment';
import InfoIconComponent from '../../components/InfoIcon';


class DomesticStep1 extends Component {

    state = {
        provinces: []
    }
    constructor(props) {
        super(props);
        this.initData();
    }

    async initData() {
        try {
            const res = await DataService.getProvinces();
            const provinces = res.provinces.map(province => {
                return {
                    value: province.id,
                    label: province.name_th
                }
            })
            this.setState({ ...this.state, provinces })
        }
        catch(e) {
            console.error(e)
        }
    }

    onChangeDelivery = (selected) => {
        const { onChangeModel } = this.context.step1;
        onChangeModel({ name: 'deliveryBy', value: selected})
        onChangeModel({ name: 'deliveryByOther', value: ''})
        setTimeout(() => {
            const txtDeliveryByOther = document.getElementById('deliveryByOther');
            if(txtDeliveryByOther) {
                txtDeliveryByOther.focus()
            }
        }, 100)
    }

    _onSelectProvinceOther = (selected) => {
        const { onChangeModel } = this.context.step1;
        if(selected && selected.length > 3) {
            Alert.alertWithTitle(' กรุณากรอกข้อมูลให้ถูกต้อง','ท่านสามารถเพิ่มรายชื่อจังหวัดได้สูงสุด 3 จังหวัดเท่านั้น', 'warning');
            // alert('ขออภัยค่ะ ท่านสามารถเพิ่มรายชื่อจังหวัดได้สูงสุด 3 จังหวัดเท่านั้น หากต้องการ เพิ่มเติม กรุณาติดต่อเจ้าหน้าที่');
        } else {
            onChangeModel({ name: 'provinceOther', value: selected})
        }
    }

    onChangeDate(name, value) {
        const { onChangeModel, onUpdatePlan, counter } =  this.context.step1;
        onChangeModel({ name, value });
        // , async () => {
        //     const { diffDate } = this.context;
        //     if(diffDate && typeof diffDate === 'number') {
        //         let plans = await CalculateService.rate({ type_code: TYPE_CODES.TA, day: diffDate, counter })
        //         plans = plans.map((plan, i) => {
        //             return {
        //                 ...plan,
        //                 title: `ทุนประกัน (แผนที่ ${i + 1})`
        //             }
        //         })
        //         onUpdatePlan(plans);
        //     }
        // })
    }

    render() {
        const { provinces } = this.state;
        const { diffDate, step1 } = this.context;
        const { 
            type,
            langague,
            start_date, 
            end_date,
            deliveryBy,
            deliveryByOther,
            counter,
            purposeTour,
            provinceFrom,
            provinceTo,
            provinceOther,
            onChangeModel,
            onChangeDate,
        } = step1;

        const today = new Date(DateUtils.getCurrentPlusOneTh(null, 'YYYY-MM-DD'));
        const minEndDate = start_date ? new Date(DateUtils.getCurrentPlusOneTh(start_date, 'YYYY-MM-DD')) : today;
        const maxEndDate = new Date(moment.utc(start_date || today).add(30, 'days').format('YYYY-MM-DD'));
        
        return (
            <div className="form-wrapper">
                <div className="form-group">
                    <label>เดินทางโดย</label>
                    <div className="d-flex">
                        <SelectComponent 
                            options={DELIVERY_BY}
                            selected={deliveryBy}
                            onChange={this.onChangeDelivery}
                        />
                        {
                            deliveryBy &&
                            deliveryBy.value === 'อื่นๆ' &&
                            <Fragment>
                                <SpaceBox />
                                <input id="deliveryByOther" type="text"
                                    className="form-control" 
                                    placeholder="อื่นๆ"
                                    name="deliveryByOther"
                                    value={deliveryByOther}
                                    onChange={(e) => onChangeModel({ name: e.target.name, value: e.target.value })} />
                            </Fragment>
                        }
                    </div>
                </div>
                <div className="form-group">
                    <label>ประเภทการเดินทาง</label>
                    <div className="d-flex">
                        <div className={ `rectangle ${type === 3 ? 'active' : ''}` } 
                            onClick={() => onChangeModel({ name: 'type', value: 3 })}>
                            <img className="m-auto" src={DomTypeDelivery1} width="24px" height="24px" />
                            <p>เที่ยวเดียว</p>
                        </div>
                        <div className={ `rectangle ${type === 4 ? 'active' : ''}` }
                            onClick={() => onChangeModel({ name: 'type', value: 4 })}>
                            <img className="m-auto" src={DomTypeDelivery2} width="24px" height="24px" />
                            <p>ไป - กลับ</p>
                        </div>
                    </div>
                </div>

                {/* ################## */}
                {/* Select Provice */}
                {/* ################## */}
                <div className="form-group">
                    {/* Select Label */}
                    <div className="d-flex">
                        <div className="flex-1">
                            <label>จังหวัดต้นทาง</label>
                        </div>
                        <SpaceBox w="24px" />
                        <div className="flex-1">
                            <label>จังหวัดปลายทาง</label>
                        </div>
                    </div>
                    {/* Select Control */}
                    <div className="d-flex align-item-center">
                        <div className="flex-1">
                            <SelectComponent 
                                options={provinces}
                                selected={provinceFrom}
                                onChange={(selected) => onChangeModel({ name: 'provinceFrom', value: selected})}
                            />
                            {/* <select
                                className="form-control date-inputmask"
                                id="provinceFrom"
                                name="provinceFrom"
                                value=""
                            >
                                <option value="" disabled>จังหวัด</option>
                            </select> */}
                        </div>
                        <img src={ArrowBlue} width="24px" height="24px" style={{ margin: '0px 4px'}} />
                        <div className="flex-1">
                            <SelectComponent 
                                options={provinces}
                                selected={provinceTo}
                                onChange={(selected) => onChangeModel({ name: 'provinceTo', value: selected})}
                            />
                            {/* <select
                                className="form-control date-inputmask"
                                id="provinceTo"
                                name="provinceTo"
                                value="">
                                <option value="" disabled>จังหวัด</option>
                            </select> */}
                        </div>
                    </div>
                </div>
                {/* Add More Provice */}
                <div className="form-group">
                    <label>เพิ่มรายชื่อจังหวัด (ถ้ามี)</label>
                    <InfoIconComponent id="provinceOther" text="ระบุเพิ่มเติมกรณีที่มีการเดินทางนอกเส้นทางจากต้นทางถึงปลายทาง" />
                    <SelectComponent 
                            isMulti
                            options={provinces}
                            selected={provinceOther}
                            onChange={this._onSelectProvinceOther}
                        />
                    {/* <select
                        className="form-control date-inputmask"
                        id="addMoreProvice"
                        name="deliveryBy"
                        value=""
                    >
                        <option value="" disabled>จังหวัด</option>
                    </select> */}
                </div>
                {/* ################## */}
                {/* End Select Provice */}
                {/* ################## */}

                {/* ################## */}
                {/** Start - End Date **/}
                {/* ################## */}
                <div className="form-group">
                    <div className="d-flex">
                        <label>วันที่เดินทาง</label>
                        <InfoIconComponent id="diffDate" text="เวลาเริ่ม 00.01 น.-เวลาสิ้นสุดการคุ้มครอง 24.00 น." />
                        <div className="ml-auto">
                            <p className="text-dark-blue"><b>{diffDate}</b> วัน</p>
                        </div>
                    </div>
                    <div className="d-flex">
                        <DatePickerComponent 
                            minDate={today}
                            maxDate={end_date ? new Date(end_date) : ''}
                            selected={start_date ? new Date(start_date) : ''}
                            
                            placeholderText="วันที่เริ่มต้น"
                            onChange={(date) => onChangeDate({ name:'start_date', value: date}) }
                            dateFormat="dd/MM/yyyy"
                            showTimeSelect={false}
                            popperPlacement="top-start"
                            />
                        <SpaceBox />
                        <DatePickerComponent 
                            minDate={minEndDate}
                            maxDate={maxEndDate}
                            selected={end_date ? new Date(end_date) : ''}

                            placeholderText="วันที่สิ้นสุด"
                            onChange={(date) => onChangeDate({ name:'end_date', value: date}) }
                            dateFormat="dd/MM/yyyy"
                            popperPlacement="top-end"
                            showTimeSelect={false}
                            />
                    </div>
                </div>
                {/* ################## */}
                {/*** End Date Picker **/}
                {/* ################## */}


                {/* ################## */}
                {/*** Counter Section **/}
                {/* ################## */}
                <div className="form-group">
                    <div className="d-flex align-item-center">
                        <label className="mb-0 ml-1">จำนวนผู้เอาประกัน</label>
                        <CounterConponent 
                            counter={counter}
                            onChange={(counter) => onChangeModel({ name: 'counter', value: counter })}
                            className="ml-auto mr-3"
                        />
                    </div>
                    <p className="text-helper">* ช่วงอายุ 1 ปี - 60 ปี</p>
                </div>
                {/* ################## */}
                {/* End Counter Section */}
                {/* ################## */}

                <div className="form-group">
                    <label>วัตถุประสงค์ของการท่องเที่ยว</label>
                    <InfoIconComponent id="purposeTour" text="กิจกรรมที่ไม่ได้รับความคุ้มครอง ได้แก่ ล่าสัตว์, แข่งรถหรือแข่งเรือทุกชนิด, แข่งม้า, เล่นหรือแข่งสกีทุกชนิดรวมถึงเจ็ตสกี, แข่งสเก็ต, ชกมวย, โดดร่ม (เว้นแต่เป็นการโดดร่มเพื่อรักษาชีวิต), ขณะกำลังขึ้นหรือกำลังลงหรือโดยสารอยู่ในบอลลูน, เครื่องร่อน, เล่นบันจี้จั๊มพ์, ปีนหรือไต่เขา, ดำน้ำที่ต้องใช้ถังอากาศ" />
                    <SelectComponent 
                        options={PURPOSE_OF_TOURISM}
                        selected={purposeTour}
                        onChange={(selected) => onChangeModel({ name: 'purposeTour', value: selected})}
                    />
                </div>
                <div className="form-group">
                    <label>เอกสารกรมธรรม์</label>
                    <div className="d-flex">
                        <div className={`radio-button align-item-center ${langague === 1 ? "active" : ""}`}
                            onClick={() => onChangeModel({ name: 'langague', value: 1 })}>
                            <div className="radio" />
                            <p>ไทย</p>
                        </div>
                        <div className={`radio-button align-item-center ${langague === 2 ? "active" : ""}`}
                            onClick={() => onChangeModel({ name: 'langague', value: 2 })}>
                            <div className="radio" />
                            <p>อังกฤษ</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

DomesticStep1.contextType = DomesticContext;
export default withRouter(DomesticStep1);